import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FocusDirective } from '../directives/focus.directive';
import { EnumPipe } from '../pipes/enum.pipe';
import { LogoComponent } from '../components/logo/logo.component';
import { AvatarComponent } from '../components/avatar/avatar.component';
import { FindComponent } from '../components/find/find.component';
import { MaterialModule } from './material.module';
import { DragDropDirective } from '../directives/drag-drop.directive';
import { PaginatorComponent } from '../components/paginator/paginator.component';
import { CounterComponent } from '../components/counter/counter.component';
import { UploaderComponent } from '../components/uploader/uploader.component';
import { DialogComponent } from '../components/dialog/dialog.component';
import { TooltipListPipe } from '../pipes/tooltip-list.pipe';
import { ListFilesComponent } from '../components/list-files/list-files.component';
import { NumberSelectorComponent } from '../components/number-selector/number-selector.component';
import { CircularSliderComponent } from '../components/circular-slider/circular-slider.component';
import { StarRatingComponent } from '../components/star-rating/star-rating.component';

@NgModule({
  declarations: [
    StarRatingComponent,
    LogoComponent,
    AvatarComponent,
    FindComponent,
    PaginatorComponent,
    CounterComponent,
    UploaderComponent,
    ListFilesComponent,
    FocusDirective,
    DragDropDirective,
    DialogComponent,
    NumberSelectorComponent,
    CircularSliderComponent,
    //shared pipes goes there
    EnumPipe,
    TooltipListPipe,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    CommonModule,
    MaterialModule,
    TranslateModule.forChild()
  ],
  exports: [
    FormsModule,
    StarRatingComponent,
    ReactiveFormsModule,
    FlexLayoutModule,
    FocusDirective,
    LogoComponent,
    FindComponent,
    PaginatorComponent,
    CounterComponent,
    AvatarComponent,
    UploaderComponent,
    ListFilesComponent,
    DragDropDirective,
    DialogComponent,
    NumberSelectorComponent,
    CircularSliderComponent,
    //and there
    EnumPipe,
    TooltipListPipe,
  ],
})
export class SharedModule { }
